import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { Miscellaneous } from "src/types/graphql.d";
import { useFreeShippingThresholdLabel } from "src/hooks/use-free-shipping-threshold";
import { resolveFreeShippingThreshold } from "src/utils/freeShippingThresholdText";

const MISCELLANEOUS = gql`
  query miscellaneous {
    miscellaneous {
      header
      footer
      pdp {
        delivery
        returns
        shipping
        otriumOffers
        paymentAndShipping {
          title
          copy
        }
        brandSizeFitSmallList
        categoriesSizeFitSmallList
      }
    }
  }
`;

interface MiscellaneousData {
  miscellaneous: Miscellaneous;
}

interface useMiscellaneousProps {
  data: MiscellaneousData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const useMiscellaneous = (): useMiscellaneousProps => {
  const { data, loading, error } = useQuery<MiscellaneousData>(MISCELLANEOUS, {
    fetchPolicy: "cache-first",
  });
  const freeShippingThreshold = useFreeShippingThresholdLabel();

  const resolvedData = useMemo(() => {
    if (!data) return data;

    return {
      ...data,
      miscellaneous: resolveFreeShippingThreshold(
        data.miscellaneous,
        freeShippingThreshold
      ),
    };
  }, [data, freeShippingThreshold]);

  return { data: resolvedData, loading, error };
};

export { useMiscellaneous, MISCELLANEOUS };
